import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

class PersonSeo extends React.Component {
  render() {
    const { item } = this.props
    // JSON+LDの設定
    const jsonLd = {
      "@context": "https://schema.org/",
      "@type": "Person",
      "name": item.name,
      "jobTitle": item.honorific,
      "workLocation": `${item.prefecture_name}${item.city_name}${item.street_number}`,
      "worksFor": item.company_name,
      "url": `https://keyman-db.smart-letter.com/keymans/${item.id}`
    }

    // 電話番号
    if (item && item.shikiho_tel) {
      jsonLd.telephone = item.shikiho_tel
    }

    return (
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
    )
  }
}

PersonSeo.propTypes = {
  item: PropTypes.object,
}

export default PersonSeo